import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    statusFilter: "All",
};

export const viewCreatedJdsSlice = createSlice({
    name: "viewCreatedJds",
    initialState,
    reducers: {
        setStatusFilter: (state, action) => {
            state.statusFilter = action.payload;
        },
        resetStatusFilter: (state) => {
            state.statusFilter = "All";
        },
    },
});

export const { setStatusFilter, resetStatusFilter } = viewCreatedJdsSlice.actions;
export default viewCreatedJdsSlice.reducer;
